import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LikutSubSQL, ScanHistoryItem, scanHistoryOriginSource } from '@interfaces/likut';
import { LikutScanService } from '@services/likut-scan.service';
import { LikutService } from '@services/likut.service';
import { MAXIMUM_PACK_QUANTITY } from '@utils/constants-products';
import { Subject, map, combineLatest, takeUntil } from 'rxjs';

@Component({
	selector: 'app-likut-task-manually-add-scan',
	templateUrl: './likut-task-manually-add-scan.component.html',
	styleUrls: [`./likut-task-manually-add-scan.component.scss`],
})
export class LikutTaskManuallyAddScanComponent implements OnDestroy {
	_likutScan = inject(LikutScanService);
	private fb = inject(FormBuilder);
	private dialogRef = inject(MatDialogRef<LikutTaskManuallyAddScanComponent>);

	constructor(@Inject(MAT_DIALOG_DATA) private data: LikutSubSQL) {}

	form = this.fb.group({
		quantity: [<string>null, [Validators.required, Validators.max(MAXIMUM_PACK_QUANTITY), Validators.pattern(`^ *[0-9]+(.[0-9]{0,8})? *$`)]],
	});

	private readonly likut = this.data;

	submitQuantity$ = new Subject<boolean>();

	private readonly destroy$ = new Subject<void>();

	// TODO Instead of injecting, use a service to get the data, and then display it in the table
	// ngOnInit() {
	// this._likutScan.likutBarcodeScansDisplay$.pipe(takeUntil(this.destroy$)).subscribe(filter => {
	// 	if (!filter?.length) {
	// 		this.dialogRef.close();
	// 	}
	// });
	// }

	close() {
		this.dialogRef.close();
	}

	errorMessage() {
		if (this.form.controls.quantity.hasError('required')) {
			return 'יש להזין כמות';
		}
		if (this.form.controls.quantity.hasError('pattern') || this.form.controls.quantity.hasError('max')) {
			return 'כמות לא תקינה';
		}

		return '';
	}

	onSubmit() {
		if (this.form.invalid) {
			return;
		}

		const quantity = +this.form.value.quantity;

		const weight = +new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, useGrouping: false }).format(quantity);

		this._likutScan.addCustomBarcodeScan({ quantity: weight, task: this.likut, source: scanHistoryOriginSource.popupScreen_Manual, barcode: '' });

		this.form.controls.quantity.reset();
		this.form.controls.quantity.setErrors(null);
		this.form.controls.quantity.markAsPristine();
		this.form.controls.quantity.markAsUntouched();

		this.submitQuantity$.next(true);
	}

	quantityChanged(newValue: string) {
		this.form.controls.quantity.setValue(newValue);
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
